import { Box } from 'components/Box/Box';
import { Form } from 'components/Form/Form';
import type { FormSubmitFunction } from 'components/Form/FormContext';
import { ImagePickerField } from 'components/Form/ImagePickerField';
import type { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import type { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { isOrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { trackClicked } from 'utils/analytics/track/trackClicked';

import { Banner } from './components/Banner';
import { OrgPreviewInfo } from './components/OrgPreviewInfo';

type Props = {
  org: ApiOrg | OrgDashboardApiOrg;
  isPreview: boolean;
  isPublished: boolean;
  orgOwner: boolean;
  editMode: boolean;
  onSubmit: FormSubmitFunction<
    Pick<OrgDashboardApiOrg, 'id'> & Partial<OrgDashboardApiOrg>
  >;
};

export function ViewOrgPageBanner({
  org,
  isPreview,
  isPublished,
  orgOwner,
  editMode,
  onSubmit,
}: Props) {
  return (
    <>
      {isPreview &&
        !isPublished &&
        !org.isFrozen &&
        isOrgDashboardApiOrg(org) && <OrgPreviewInfo org={org} />}

      <Box height={[orgOwner ? 80 : 35, null, null, 200]}>
        {orgOwner && editMode ? (
          <Form
            analyticsTitle="[main] Org page - banner"
            usageContext="page"
            initialValues={{
              banner: org.banner,
              id: org.id,
            }}
            onSubmit={onSubmit}
            render={({ submitForm }) => (
              <ImagePickerField
                name="banner"
                format="banner"
                message={getText('Drag a banner image here')}
                aspectRatio={7.2}
                altText={org.name}
                overlayButton
                onChange={(image) => {
                  trackClicked(`Org profile: upload banner`);
                  submitForm({ banner: image });
                }}
                confirmModal
                extraAnalyticsData={{
                  context: 'Org Page',
                  file_type: 'Org Banner',
                  file_label: 'Drag a banner image here',
                }}
              />
            )}
          />
        ) : (
          org.banner && (
            <Banner
              $handle={org.banner.handle}
              $mimetype={org.banner.mimetype}
              data-qa-id="banner-image"
            />
          )
        )}
      </Box>
    </>
  );
}
